import _asyncToGenerator from '../../../@babel/runtime/helpers/esm/asyncToGenerator.js';
import _wrapNativeSuper from '../../../@babel/runtime/helpers/esm/wrapNativeSuper.js';
import _classCallCheck from '../../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../../@babel/runtime/helpers/esm/createClass.js';
import _get from '../../../@babel/runtime/helpers/esm/get.js';
import _inherits from '../../../@babel/runtime/helpers/esm/inherits.js';
import _possibleConstructorReturn from '../../../@babel/runtime/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '../../../@babel/runtime/helpers/esm/getPrototypeOf.js';
import regenerator from '../../../@babel/runtime/regenerator/index.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Slotify = function Slotify(superclass) {
  var DEFAULT_SLOT_INTROSPECTION_OPTIONS = {
    ignoreComments: false,
    ignoreWhitespace: false
  };
  return /*#__PURE__*/function (_superclass) {
    _inherits(_class, _superclass);
    var _super = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      _this = _super.call(this);
      if (!customElements.get('s-root')) {
        var SRoot = /*#__PURE__*/function (_HTMLElement) {
          _inherits(SRoot, _HTMLElement);
          var _super2 = _createSuper(SRoot);
          function SRoot() {
            _classCallCheck(this, SRoot);
            return _super2.apply(this, arguments);
          }
          return _createClass(SRoot);
        }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
        customElements.define('s-root', SRoot);
      }
      if (!customElements.get('s-slot')) {
        var SSlot = /*#__PURE__*/function (_HTMLElement2) {
          _inherits(SSlot, _HTMLElement2);
          var _super3 = _createSuper(SSlot);
          function SSlot() {
            var _this2;
            _classCallCheck(this, SSlot);
            _this2 = _super3.call(this);
            _this2.name = _this2.getAttribute('name');
            _this2._slotRendered = false;
            _this2._slotRenderAttempts = 0;
            _this2._maxSlotRenderAttempts = 10;
            return _this2;
          }
          _createClass(SSlot, [{
            key: "connectedCallback",
            value: function connectedCallback() {
              var _this3 = this;
              this._slotUpdateCompleted = new Promise(function (resolve, reject) {
                var id = setInterval(function () {
                  _this3._slotRenderAttempts++;
                  try {
                    if (_this3._slotRendered) {
                      clearInterval(id);
                      resolve();
                    } else if (_this3._slotRenderAttempts >= _this3._maxSlotRenderAttempts) {
                      throw new Error('Slot Rendering Timeout');
                    }
                  } catch (e) {
                    clearInterval(id);
                    reject(e);
                  }
                }, 50);
              });

              // closest() polyfill for IE11
              if (!Element.prototype.matches) {
                Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
              }
              if (!Element.prototype.closest) {
                Element.prototype.closest = function (s) {
                  var el = this;
                  do {
                    if (el.matches(s)) return el;
                    el = el.parentElement || el.parentNode;
                  } while (el !== null && el.nodeType === 1);
                  return null;
                };
              }
              this.sRoot = this.closest('s-root');

              // Observe the "Light DOM" of the component, to detect when new nodes are added and assign them to the <s-slot> if necessary
              this.lightDomObserver = new MutationObserver(function () {
                _this3._slotRendered = false;
                _this3.updateAssignedContent();
              });
              this.lightDomObserver.observe(this.sRoot.parentElement, {
                childList: true
              });

              // Create assigned content and fallback content wrappers
              this.fallbackWrapper = this.fallbackWrapper || this.createFallbackWrapper();
              this.assignedWrapper = this.assignedWrapper || this.createAssignedWrapper();

              // Observe the assignedContentWrapper (so default content can be shown if all slotables are deleted)
              var assignedContentObserver = new MutationObserver(function () {
                _this3._slotRendered = false;
                _this3.updateEmptySlot(); // This is an observer on the actual <s-slot>
                _this3.dispatchEvent(new CustomEvent('slotchange', {
                  bubbles: true
                }));
              });
              assignedContentObserver.observe(this.assignedWrapper, {
                childList: true
              });
              this.updateAssignedContent();
            }
          }, {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
              this.lightDomObserver.disconnect(); // don't let observers pile up
              var element = this.sRoot && this.sRoot.parentElement;
              var fragment = document.createDocumentFragment();
              Array.from(this.assignedWrapper.childNodes).forEach(function (child) {
                fragment.appendChild(child);
              });
              if (element) {
                element.appendChild(fragment);
              }
              this.sRoot = null;
            }
          }, {
            key: "createFallbackWrapper",
            value: function createFallbackWrapper() {
              if (!customElements.get('s-fallback-wrapper')) {
                var SFallbackWrapper = /*#__PURE__*/function (_HTMLElement3) {
                  _inherits(SFallbackWrapper, _HTMLElement3);
                  var _super4 = _createSuper(SFallbackWrapper);
                  function SFallbackWrapper() {
                    _classCallCheck(this, SFallbackWrapper);
                    return _super4.apply(this, arguments);
                  }
                  return _createClass(SFallbackWrapper);
                }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
                customElements.define('s-fallback-wrapper', SFallbackWrapper);
              }
              var fallbackNodes = Array.from(this.childNodes).filter(function (n) {
                return n.tagName === undefined || n.tagName.toLowerCase() !== 's-assigned-wrapper';
              });
              // This is only called once, get the contents of this <s-slot> and wrap them in a span
              if (fallbackNodes.length === 0) {
                // there's no default content, don't create the wrapper
                return false;
              } else {
                var fallbackWrapper = document.createElement('s-fallback-wrapper');
                fallbackNodes.forEach(function (node) {
                  fallbackWrapper.appendChild(node);
                });
                this.appendChild(fallbackWrapper); // Add the fallback span to the component;
                return fallbackWrapper;
              }
            }
          }, {
            key: "createAssignedWrapper",
            value: function createAssignedWrapper() {
              if (!customElements.get('s-assigned-wrapper')) {
                var SAssignedWrapper = /*#__PURE__*/function (_HTMLElement4) {
                  _inherits(SAssignedWrapper, _HTMLElement4);
                  var _super5 = _createSuper(SAssignedWrapper);
                  function SAssignedWrapper() {
                    _classCallCheck(this, SAssignedWrapper);
                    return _super5.apply(this, arguments);
                  }
                  return _createClass(SAssignedWrapper);
                }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
                customElements.define('s-assigned-wrapper', SAssignedWrapper);
              }
              var assignedWrapper = document.createElement('s-assigned-wrapper');
              this.appendChild(assignedWrapper); // Add the assigned span to the component;
              return assignedWrapper;
            }
          }, {
            key: "updateAssignedContent",
            value: function updateAssignedContent() {
              var _this4 = this;
              var lightDOM = this.sRoot.parentElement;
              var unplacedNodes = Array.from(lightDOM.childNodes).filter(function (node) {
                return node.parentNode === _this4.sRoot.parentElement && node !== _this4.sRoot; // return all nodes outside the <s-root>, they haven't been moved yet
              });

              var content = [];
              if (this.name) {
                // Handle named slots
                content = unplacedNodes.filter(function (node) {
                  return node.nodeType === Node.ELEMENT_NODE && node.getAttribute('slot') === _this4.name;
                });
              } else {
                // Handle default slot content
                content = unplacedNodes.filter(function (n) {
                  if (n.nodeType !== Node.ELEMENT_NODE) {
                    return n;
                  } else if (typeof n.getAttribute === 'function' && !n.getAttribute('slot')) {
                    return n;
                  }
                });
              }
              if (content.length > 0) {
                // Some slotable content was found, remove default content
                var fragment = document.createDocumentFragment();
                content.forEach(function (node) {
                  fragment.appendChild(node);
                });
                this.assignedWrapper.appendChild(fragment);
                if (this.fallbackWrapper) {
                  this.fallbackWrapper.setAttribute('hidden', true);
                  this.assignedWrapper.removeAttribute('hidden'); // Do a visibility toggle so the mutationObserver will not be triggered and create a loop
                }
              }

              this._slotRendered = true;
            }
          }, {
            key: "updateEmptySlot",
            value: function updateEmptySlot() {
              if (this.fallbackWrapper && this.assignedWrapper.childNodes.length === 0) {
                this.fallbackWrapper.removeAttribute('hidden');
                this.assignedWrapper.setAttribute('hidden', true); // Do a visibility toggle so the mutationObserver will not be triggered and create a loop
              }

              this._slotRendered = true;
            }
          }]);
          return SSlot;
        }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
        customElements.define('s-slot', SSlot);
      }
      return _this;
    }
    _createClass(_class, [{
      key: "createRenderRoot",
      value: function createRenderRoot() {
        // Wrap the entire rendered output in an <s-root> element
        // Check for existing <s-root> element
        // Array.find would be nice here, but IE11 doesn't like it. More verbose code to avoid polyfilling Array.find for IE11
        var existingSRoot = undefined;
        Array.from(this.childNodes).forEach(function (n) {
          if (n.tagName && n.tagName.toLowerCase() === 's-root') {
            existingSRoot = n;
          }
        });
        if (existingSRoot !== undefined) {
          return existingSRoot;
        } else {
          return document.createElement('s-root');
        }
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        // Ensure the contents are wrapped in the <s-root> element
        if (!this.renderRoot.parentElement) {
          this.appendChild(this.renderRoot);
        }
        _get(_getPrototypeOf(_class.prototype), "connectedCallback", this).call(this);
      }
    }, {
      key: "_getUpdateComplete",
      value: function () {
        var _getUpdateComplete2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
          var slotPromises;
          return regenerator.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(_class.prototype), "_getUpdateComplete", this).call(this);
              case 2:
                slotPromises = Array.from(this.querySelectorAll('s-slot')).map(function (s) {
                  return s._slotUpdateCompleted;
                });
                _context.next = 5;
                return Promise.all(slotPromises);
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function _getUpdateComplete() {
          return _getUpdateComplete2.apply(this, arguments);
        }
        return _getUpdateComplete;
      }()
      /*
       * After the component has rendered, this method can be used to retrieve the content assigned to a slot
       */
    }, {
      key: "getAssignedSlotContent",
      value: function getAssignedSlotContent() {
        var slotName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var slot;
        if (slotName === 'default') {
          slot = Array.from(this.querySelectorAll('s-slot')).filter(function (n) {
            return n.getAttribute('name') === null;
          }).pop();
        } else {
          slot = this.querySelector("s-slot[name='".concat(slotName, "']"));
        }
        if (!slot) return undefined; // Component hasn't rendered yet, no slot to query

        var slotContent = slot.querySelector('s-assigned-wrapper');
        if (slotContent.childNodes) {
          return slotContent.childNodes;
        }
        return undefined;
      }

      /*
       * Before the component has rendered, this method can be used to retrieve child nodes that will be assigned to a slot
       */
    }, {
      key: "getSlotableContent",
      value: function getSlotableContent() {
        var slotName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var options = arguments.length > 1 ? arguments[1] : undefined;
        options = Object.assign({}, DEFAULT_SLOT_INTROSPECTION_OPTIONS, options || {});
        var slotableContent;
        if (slotName === 'default') {
          var isEmptyTextNode = function isEmptyTextNode(n) {
            return n.nodeType === Node.TEXT_NODE && (n.nodeValue == null || n.nodeValue.trim() === '');
          };

          // get all nodes outside s-root that aren't assigned to another slot
          slotableContent = Array.from(this.childNodes).filter(function (n) {
            // only Element nodes can have tagNames and attributes. if the node is something else, we can
            // safely assume that it should be moved into the default slot.

            if (options.ignoreComments && n.nodeType === Node.COMMENT_NODE) {
              return false;
            } else if (options.ignoreWhitespace && isEmptyTextNode(n)) {
              return false;
            }
            return n.nodeType !== Node.ELEMENT_NODE || n.tagName.toLowerCase() !== 's-root' && n.getAttribute('slot') === null;
          });
        } else {
          slotableContent = Array.from(this.querySelectorAll("*[slot='".concat(slotName, "']")));
        }
        return slotableContent;
      }

      /*
       * After the component has rendered, this method can be used to determine if a slot has assigned content
       */
    }, {
      key: "hasAssignedSlotContent",
      value: function hasAssignedSlotContent() {
        var slotName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var assignedSlotContent = this.getAssignedSlotContent(slotName);
        if (typeof assignedSlotContent === 'undefined') {
          return false;
        } else {
          return assignedSlotContent.length > 0;
        }
      }

      /*
       * Before the component has rendered, this method can be used to determine if a slot will have content after the component renders
       */
    }, {
      key: "hasSlotableContent",
      value: function hasSlotableContent() {
        var slotName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var options = arguments.length > 1 ? arguments[1] : undefined;
        options = Object.assign({}, DEFAULT_SLOT_INTROSPECTION_OPTIONS, options || {});
        return this.getSlotableContent(slotName, options).length > 0;
      }
    }]);
    return _class;
  }(superclass);
};

export { Slotify };
